export default function (value) {
  const formatter = new Intl.NumberFormat('nl-NL')
  return formatter.format(value)
}
